import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  sync() {
    const url = new URL(this.element.action, window.location.origin)

    new FormData(this.element).forEach((value, key) => {
      if (typeof value === "string" && value.trim() !== "") {
        url.searchParams.set(key, value)
      }
    })

    window.history.replaceState(window.history.state, "", url.toString())
  }
}
